__turbopack_context__.v({
  "className": "montserrat_aa96d381-module__ZJHDyq__className",
  "variable": "montserrat_aa96d381-module__ZJHDyq__variable",
});
